<template>
    <section>
        <OpenAPiContainer
            :userIdx="userIdx"
        ></OpenAPiContainer>
    </section>
</template>

<script>
import { computed } from '@vue/composition-api'
import store from '@/store'
import OpenAPiContainer from '@/modules/OpenApi'
import OpenApiStore from '@/modules/OpenApi/_store'
export default {
    components: {
        OpenAPiContainer
    },
    setup (props, context) {
        const userIdx = computed(() => store.getters.authUserInfo.userIdx)
        return {
            userIdx
        }
    },
    beforeRouteEnter (to, from, next) {
        const STORE_KEY = '$_open_api'
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, OpenApiStore)
        }
        store.dispatch(`${STORE_KEY}/getOpenApiKeyStatus`).then(() => {
            next()
        })
    }
}
</script>

<style>

</style>
